import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Card, CardContent } from "@/components/ui/card"
import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { Star, Quote } from "lucide-react"
import api from "@/services/api"

interface Testimonial {
  name: string
  district: string
  content: string
  rating: number
}

const fallbackTestimonials: Testimonial[] = [
  { name: "陳太太", district: "九龍塘", rating: 5, content: "透過 MaidLinks 找到了非常優秀的菲傭 Maria，她照顧我年邁的父母非常細心，已經服務了2年，全家都很滿意！" },
  { name: "李先生", district: "中環", rating: 5, content: "服務非常專業，顧問很耐心地了解我們的需求，不到一週就找到合適的印傭。強烈推薦！" },
  { name: "黃太太", district: "沙田", rating: 5, content: "之前自己找外傭遇到很多問題，這次透過 MaidLinks，整個過程很順利，外傭的質素也很好。" },
]

export function TestimonialsSection() {
  const { t } = useTranslation()
  const [testimonials, setTestimonials] = useState<Testimonial[]>(fallbackTestimonials)

  useEffect(() => {
    api.get('/testimonials')
      .then((res: any) => {
        if (res?.success && res?.data?.length > 0) {
          setTestimonials(res.data)
        }
      })
      .catch(() => {})
  }, [])

  return (
    <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-2xl font-bold text-foreground md:text-3xl">{t('home.testimonials.title')}</h2>
          <p className="mt-3 text-muted-foreground">
            {t('home.testimonials.subtitle')}
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="relative overflow-hidden">
              <CardContent className="p-6">
                <Quote className="absolute -right-2 -top-2 h-16 w-16 text-secondary/50" />
                <div className="mb-4 flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="relative z-10 text-sm text-muted-foreground">{testimonial.content}</p>
                <div className="mt-6 flex items-center gap-3">
                  <Avatar>
                    <AvatarFallback>{testimonial.name[0]}</AvatarFallback>
                  </Avatar>
                  <div>
                    <p className="font-medium text-foreground">{testimonial.name}</p>
                    <p className="text-sm text-muted-foreground">{testimonial.district}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
